import { onError } from '@apollo/client/link/error';

function errorLink(_a) {
    var handleError = _a.onError, handleNetworkError = _a.onNetworkError, handleGraphQLError = _a.onGraphQLError;
    return onError(function (error) {
        if (handleError) {
            handleError(error);
        }
        if (error.networkError && handleNetworkError) {
            handleNetworkError(error.networkError);
        }
        if (error.graphQLErrors && handleGraphQLError) {
            handleGraphQLError(error.graphQLErrors);
        }
    });
}

export default errorLink;
//# sourceMappingURL=errors.js.map
